namespace $ {
	
	export let $mol_file_extensions = {
		
		'css': 'text/css;charset=utf-8',
		'csv': 'text/csv;charset=utf-8',
		'htm': 'text/html;charset=utf-8',
		'html': 'text/html;charset=utf-8',
		'ics': 'text/calendar;charset=utf-8',
		'js': 'text/javascript;charset=utf-8',
		'jsx': 'text/javascript;charset=utf-8',
		'md': 'text/plain;charset=utf-8',
		'mjs': 'text/javascript;charset=utf-8',
		'ts': 'text/typescript;charset=utf-8',
		'tsx': 'text/typescript;charset=utf-8',
		'txt': 'text/plain;charset=utf-8',
		
		'aac': 'audio/aac',
		'mid': 'audio/midi',
		'midi': 'audio/midi',
		'mp3': 'audio/mpeg',
		'oga': 'audio/ogg',
		'opus': 'audio/opus',
		'wav': 'audio/wav',
		'weba': 'audio/webm',
		
		'apng': 'image/apng',
		'avif': 'image/avif',
		'bmp': 'image/bmp',
		'gif': 'image/gif',
		'ico': 'image/vnd.microsoft.icon',
		'jpeg': 'image/jpeg',
		'jpg': 'image/jpeg',
		'png': 'image/png',
		'svg': 'image/svg+xml',
		'tiff': 'image/tiff',
		'tif': 'image/tiff',
		'webp': 'image/webp',
		
		'avi': 'video/x-msvideo',
		'mpeg': 'video/mpeg',
		'mp4': 'video/mp4',
		'ogv': 'video/ogg',
		'webm': 'video/webm',
		'3gp': 'video/3gpp',
		'3g2': 'video/3gpp2',
		
		'otf': 'font/otf',
		'ttf': 'font/ttf',
		'woff': 'font/woff',
		'woff2': 'font/woff2',
		
		'abw': 'application/x-abiword',
		'arc': 'application/x-freearc',
		'azw': 'application/vnd.amazon.ebook',
		'bin': 'application/octet-stream',
		'bz': 'application/x-bzip',
		'bz2': 'application/x-bzip2',
		'cda': 'application/x-cdf',
		'crus': 'application/x-crus',
		'csh': 'application/x-csh',
		'doc': 'application/msword',
		'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'eot': 'application/vnd.ms-fontobject',
		'epub': 'application/epub+zip',
		'gz': 'application/gzip',
		'jar': 'application/java-archive',
		'json': 'application/json',
		'jsonld': 'application/ld+json',
		'map': 'application/json',
		'mpkg': 'application/vnd.apple.installer+xml',
		'odp': 'application/vnd.oasis.opendocument.presentation',
		'ods': 'application/vnd.oasis.opendocument.spreadsheet',
		'odt': 'application/vnd.oasis.opendocument.text',
		'ogx': 'application/ogg',
		'pdf': 'application/pdf',
		'php': 'application/x-httpd-php',
		'ppt': 'application/vnd.ms-powerpoint',
		'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
		'rar': 'application/vnd.rar',
		'rtf': 'application/rtf',
		'sh': 'application/x-sh',
		'tar': 'application/x-tar',
		'tree': 'application/x-tree',
		'vsd': 'application/vnd.visio',
		'xhtml': 'application/xhtml+xml',
		'xls': 'application/vnd.ms-excel',
		'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'xml': 'application/xml',
		'xul': 'application/vnd.mozilla.xul+xml',
		'zip': 'application/zip',
		'7z': 'application/x-7z-compressed',
		
	} as Record< string, $mol_rest_port_mime >
	
}
